// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1kQ5x","content":"styles_content__3qaRP","checkbox":"styles_checkbox__7ezBZ","checkboxLabel":"styles_checkboxLabel__ecj7h"};